const AssortiMass = [
  {
    id: 1,
    title: 'Оселедець з картоплею та цибулею 80/100/50',
    price: '180 грн',
    src: require('../img/oseledecKart.png'),
    text: 'філе оселедця, картопля, маринована цибуля, кріп',
    isNew: true,
    allergy: `🐟 риба`
  },
  {
    id: 2,
    title: "м'ясна тарілка 200г",
    price: '390 грн',
    src: require('../img/meattarelka.png'),
    text: 'Шинка, Ковбаса СК, бастурма, хамон',
  },
  {
    id: 3,
    title: 'тарілка під пиво 200г',
    price: '340 грн',
    src: require('../img/tarpidbear.png'),
    text: "курка в'ялена, хамон, бастурма, фісташки",
    allergy: `🌰 горіхи (фісташки)`
  },

  {
    id: 4,
    title: 'дошка під горілку 150/30/30',
    price: '280 грн',
    src: require('../img/tovodka.png'),
    text: 'сало, підчеревок, корнішони, гірчиця, хрін, хліб бородинський, цибуля',
    allergy: `🌶️ гірчиця (соус), 🌾 глютен (бородинський хліб)`
  },
  {
    id: 5,
    title: 'сирна тарілка 350г/50г',
    price: '400 грн',
    src: require('../img/tarelkachees.png'),
    text: 'гауда, пармезан, брі, дорблю, мед, виноград, груша',
    allergy: `🥛 молоко (усі сири), 🍯 мед (може спричинити реакцію у чутливих осіб), ⚠️ пліснява (дорблю містить плісняві культури)`
  },
  {
    id: 6,
    title: 'фруктова тарілка 480г',
    price: '320 грн',
    src: require('../img/fruttar.webp'),
    text: 'Апельсин, виноград, ківі, груша, мараскінова вишня',
    allergy: `🍋 цитрус (апельсин),🥝 фрукти (ківі може викликати реакцію)`
  },
  {
    id: 7,
    title: 'оливки 80г',
    price: '100 грн',
    src: require('../img/olivki.png'),
  },
  {
    id: 8,
    title: 'маслини 80г',
    price: '100 грн',
    src: require('../img/maslini.png'),
  },
];

export default AssortiMass;
